import { RouterModule } from '@angular/router';
import { CategoriesComponent } from './categories/categories.component';
import { InsurancesComponent } from './insurances/insurances.component';
import { ServiceProviderSettingComponent } from './service-provider-setting.component';
import { SubCategoriesComponent } from './sub-categories/sub-categories.component';
import { ServiceProviderEditModalModule } from '../shared/admin-setting/edit-modal/edit-modal.module';
import { CompaniesComponent } from './companies/companies.component';
import { AgeGroupsComponent } from './age-groups/age-groups.component';
import { DomainTextsComponent } from './domain-texts/domain-texts.component';
import { ServiceProvidersComponent } from './service-providers/service-providers.component';
import { ServiceProviderModalComponent } from './service-providers/service-provider-modal/service-provider-modal.component';
import { LogosComponent } from './logos/logos.component';

export const SelfReportSettingRoutesModule = RouterModule.forChild( [
        {
            path: '',
            component: ServiceProviderSettingComponent,
            redirectTo: 'categories',
            pathMatch: 'full',
            data: {
            }
        },
        {
            path: 'categories',
            component: CategoriesComponent,
            data: {
                breadcrumb: 'Categories Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'categories/create', component: CategoriesComponent
        },
        {
            path: 'categories/edit/:id', component: ServiceProviderEditModalModule
        },
        {
            path: 'sub-categories',
            component: SubCategoriesComponent,
            data: {
                breadcrumb: 'Sub-Categories Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'sub-categories/create', component: SubCategoriesComponent
        },
        {
            path: 'sub-categories/edit/:id', component: ServiceProviderEditModalModule
        },
        {
            path: 'insurances',
            component: InsurancesComponent,
            data: {
                breadcrumb: 'Insurances Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'insurances/create', component: InsurancesComponent
        },
        {
            path: 'insurances/edit/:id', component: ServiceProviderEditModalModule
        },
        {
            path: 'companies',
            component: CompaniesComponent,
            data: {
                breadcrumb: 'Companies Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'companies/create', component: CompaniesComponent
        },
        {
            path: 'companies/edit/:id', component: ServiceProviderEditModalModule
        },
        {
            path: 'age-groups',
            component: AgeGroupsComponent,
            data: {
                breadcrumb: 'Age groups Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'age-groups/create', component: AgeGroupsComponent
        },
        {
            path: 'age-groups/edit/:id', component: ServiceProviderEditModalModule
        },
        {
            path: 'domain-texts',
            component: DomainTextsComponent,
            data: {
                breadcrumb: 'Domain texts Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'domain-texts/create', component: DomainTextsComponent
        },
        {
            path: 'domain-texts/edit/:id', component: ServiceProviderEditModalModule
        },
        {
            path: 'service-providers',
            component: ServiceProvidersComponent,
            data: {
                breadcrumb: 'Service providers Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'service-providers/create', component: ServiceProvidersComponent
        },
        {
            path: 'service-providers/edit/:id', component: ServiceProviderModalComponent
        },
        {
            path: 'logos',
            component: LogosComponent,
            data: {
                breadcrumb: 'Logos Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'companies/create', component: LogosComponent
        },
        {
            path: 'companies/edit/:id', component: ServiceProviderEditModalModule
        },
    ]
);
